<template>
  <v-list-item
    class='pl-10'
    :to='item.link'
    :key='`${item.label}_${item.link}`'
    dense
    exact
  >
    <v-list-item-content class='py-0'>
      <v-list-item-title style='font-size: 13px' v-text='item.label' />
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'SidebarChildListItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
